import { createStore, applyMiddleware } from 'redux'
import reducers from './reducers'
import createSagaMiddleware from 'redux-saga'
import rootSaga from './sagas'
import { composeWithDevTools } from 'redux-devtools-extension'
import { createBrowserHistory } from 'history'
import logoutMiddleware from './middleware/timeout'
import { connectRouter, routerMiddleware } from 'connected-react-router'
export default function createReduxStore (name, initialState = {}) {
  const history = createBrowserHistory()
  const sagaMiddleware = createSagaMiddleware()
  const middleware = composeWithDevTools({
    actionsBlacklist: ['@@redux-form/REGISTER_FIELD'],
    stateSanitizer: state => {
      return {
        ...state
      }
    }
  })(
    applyMiddleware(
      routerMiddleware(history),
      sagaMiddleware,
      logoutMiddleware(10)
    )
  )
  let store = createStore(
    connectRouter(history)(reducers),
    initialState,
    middleware
  )
  sagaMiddleware.run(rootSaga)
  return { store, history }
}



// WEBPACK FOOTER //
// ./src/redux/store.js